import { InfrastructureHealthResponse } from '@/domain/Health/HealthTypes';
import { Search } from '@carbon/icons-react';
import { Input, Pagination, Table } from 'antd';
import { Dispatch, SetStateAction } from 'react';
import { columns } from './columns';
import HealthLegend from './HealthLegend';

export default function HealthDashboardTable({
	infrastructureHealthData,
	pagination,
	setPagination,
	searchValue,
	setSearchValue,
}: {
	infrastructureHealthData: InfrastructureHealthResponse | null;
	pagination: any;
	setPagination: SetStateAction<any>;
	searchValue: string;
	setSearchValue: Dispatch<SetStateAction<string>>;
}) {
	const onChangePagination = (page, pageSize) => {
		setPagination((prev) => {
			if (prev.pageSize === pageSize) {
				return { page, pageSize };
			} else {
				return { page: 1, pageSize };
			}
		});
	};

	return (
		<>
			<div className="flex justify-between mb-2 flex-wrap gap-y-2">
				<div className="w-[400px] mr-2 ">
					<Input
						prefix={<Search size={16} className="text-gray-400" />}
						placeholder="Search by Parameter, Asset, Source"
						value={searchValue}
						onChange={(e) => setSearchValue(e.target.value)}
						size="large"
					/>
				</div>
				<HealthLegend />
			</div>
			<h5 className="text-gray-600 mb-3">
				Only Assets with multiple sources (&gt;1) are shown. Assets with a single source are excluded from this table.
			</h5>

			<div className="bg-white rounded-lg shadow-sm border border-gray-200">
				<Table
					columns={columns}
					dataSource={infrastructureHealthData?.data ?? []}
					rowKey={'parameterId'}
					pagination={false}
					scroll={{ x: 1200 }}
					className="custom-table"
				/>
			</div>
			<Pagination
				className="justify-self-end"
				style={{ marginTop: '2rem' }}
				current={pagination.page}
				pageSize={pagination.pageSize}
				onChange={onChangePagination}
				defaultCurrent={1}
				total={infrastructureHealthData?.totalRecords}
				showSizeChanger={{
					options: [
						{ label: '5 / page', value: 5 },
						{ label: '10 / page', value: 10 },
						{ label: '15 / page', value: 15 },
					],
				}}
			/>
		</>
	);
}
